/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CliproConfig } from '../../models/clipro-config';

export interface GetCliproConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The Badgeur Uid.
 */
  badgeurUid: string;
}

export function getCliproConfiguration(http: HttpClient, rootUrl: string, params: GetCliproConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CliproConfig>>> {
  const rb = new RequestBuilder(rootUrl, getCliproConfiguration.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('badgeurUid', params.badgeurUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CliproConfig>>;
    })
  );
}

getCliproConfiguration.PATH = '/custom/stations/{uid}/badgeur/{badgeurUid}/clipro';
